import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { DeviceInfo } from '../device/device-info';
import { AppLogger } from '../logs/app-logger';

/**
 * SOP26_00111: añade a las peticiones al servidor el canal, el móvil y la versión de la APP
 * (el servidor los guarda en el registro de accesos) y deja en el registro de la APP las
 * peticiones que cambian datos y las que fallan
 */
export const deviceInfoInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const headers: { [name: string]: string } = {
    'X-Client-Channel': 'APP',
    'X-Device-Id': DeviceInfo.getDeviceId()
  };
  const appVersion = DeviceInfo.getAppVersion();
  if (appVersion) {
    headers['X-App-Version'] = appVersion;
  }

  const started = Date.now();
  const path = req.url.substring(environment.apiBaseUrl.length).split('?')[0];
  const changesData = req.method !== 'GET';

  return next(req.clone({ setHeaders: headers })).pipe(
    tap({
      next: (event) => {
        if (changesData && event instanceof HttpResponse) {
          AppLogger.info(`${req.method} ${path} ${event.status} (${Date.now() - started} ms)`);
        }
      },
      error: (error: unknown) => {
        const status = error instanceof HttpErrorResponse ? error.status : 0;
        const message = error instanceof HttpErrorResponse ? (error.error?.message ?? error.message) : String(error);
        AppLogger.error(`${req.method} ${path} ${status} (${Date.now() - started} ms)`, message);
      }
    })
  );
};
